import EventsWithPopover from '../EventsWithPopover'
import { CellInfo } from '../types'

export const FutureEventsCell = (info: CellInfo) => {
  const {
    row: { original: profileData },
    meta: { attendingEvents, hasAccessToAlerts },
  } = info

  return <EventsWithPopover profileData={profileData} attendingEvents={attendingEvents} isSubscriber={hasAccessToAlerts} />
}
